import { FC, useState } from 'react';
import { Box, Button, CircularProgress, Grid, Typography } from '@mui/material';
import { AvaSuburbListDownloadCsvModal } from './AvaSuburbListDownloadCsvModal';
import { useGetSuburbsListQuery } from '@services';
import AvaSuburbListUploadCsvModal from './AvaSuburbListUploadCsvModal';
import { LoadingSpinner } from '@components';

const AvaSuburbList: FC = () => {
  const [isCsvUploadModalOpen, setCsvUploadModalOpen] = useState(false);
  const { data: suburbs, isFetching } = useGetSuburbsListQuery();

  if (isFetching) {
    <Box sx={{ height: '100vh' }} display="flex" alignItems="center" justifyContent="center" data-testid="ava-loader">
      <CircularProgress color="inherit" size={75} />
    </Box>;
  }

  return isFetching ? (
    <LoadingSpinner isOpen={isFetching} />
  ) : (
    <Grid container spacing={2} p={2}>
      <Grid item xs={10}>
        <Typography variant="body1" p={2}>
          To modify the suburb list :
        </Typography>
        <Typography variant="body2">1. Download the existing list via the "Download Suburb List" Button.</Typography>
        <Typography variant="body2">2. Open CSV using Excel or Numbers.</Typography>
        <Typography variant="body2">
          3. To Add Suburbs - add a row to the bottom of the CSV file and add data for the new suburb.
        </Typography>
        <Typography variant="body2">4. To Remove Suburbs - delete the row from CSV file for that suburb.</Typography>
        <Typography variant="body2">5. Save the file as a CSV.</Typography>
        <Typography variant="body2">6. Upload the updated CSV file to the input below.</Typography>
      </Grid>
      <Grid item xs={10}>
        <Typography variant="body2" sx={{ textDecoration: 'underline' }}>
          Download Suburb List
        </Typography>
        {suburbs && <AvaSuburbListDownloadCsvModal rows={suburbs} data-testid="ava-suburb-list-download-csv-btn" />}
      </Grid>
      <Grid item xs={10}>
        <Typography variant="body2" sx={{ textDecoration: 'underline' }}>
          Upload Updated List
        </Typography>
        <Button variant="contained" sx={{ mr: 2 }} onClick={() => setCsvUploadModalOpen(true)} data-testid="ava-suburb-list-upload-csv-btn">
          Upload CSV
        </Button>
        <AvaSuburbListUploadCsvModal isOpen={isCsvUploadModalOpen} onClose={() => setCsvUploadModalOpen(false)} />
      </Grid>
    </Grid>
  );
};

export default AvaSuburbList;
